import { render, staticRenderFns } from "./VisitReasonModal.vue?vue&type=template&id=fca8c308&"
import script from "./VisitReasonModal.vue?vue&type=script&lang=js&"
export * from "./VisitReasonModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/cjzhi98/chatwoot-saas/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('fca8c308')) {
      api.createRecord('fca8c308', component.options)
    } else {
      api.reload('fca8c308', component.options)
    }
    module.hot.accept("./VisitReasonModal.vue?vue&type=template&id=fca8c308&", function () {
      api.rerender('fca8c308', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/dashboard/routes/dashboard/coLiving/components/VisitReasonModal.vue"
export default component.exports